import React from 'react';
import './MaterialResult.css';

const MaterialResult = ({ materials }) => {
  // Calculate total cost
  const totalCost = materials.reduce((sum, m) => {
    const price = m.price_per_unit;
    const qty = m.required_quantity;
    return sum + (price ? price * qty : 0);
  }, 0);

  return (
    <div className="result-container">
      <h3 className="result-title">Required Materials</h3>
      <div className="result-table-wrapper">
        <table className="result-table">
          <thead>
            <tr>
              <th>Material</th>
              <th>Quantity</th>
              <th>Unit</th>
              <th>Price/Unit</th>
              <th>Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {materials.map((m, index) => {
              const quantity = isNaN(m.required_quantity) ? 0 : Math.ceil(m.required_quantity);
              const price = m.price_per_unit;
              const total = price ? (quantity * price).toFixed(2) : '—';

              return (
                <tr key={index}>
                  <td>{m.material_name}</td>
                  <td>{quantity}</td>
                  <td>{m.material_unit}</td>
                  <td>{price ? `₹${price.toFixed(2)}` : 'Not uploaded'}</td>
                  <td>{price ? `₹${total}` : '—'}</td>
                </tr>
              );
            })}
            <tr className="total-row">
              <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Estimated Cost:</td>
              <td style={{ fontWeight: 'bold' }}>₹{totalCost.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MaterialResult;
